import { type ReactNode, useEffect } from 'react'

import { trackTrailerModalViewed } from '../../events'

interface ContinuousTrailersModalControlProps {
  control: ReactNode
  courseSlug?: string
}

export const ContinuousTrailersModalControl = ({
  control,
  courseSlug,
}: ContinuousTrailersModalControlProps) => {
  useEffect(() => {
    trackTrailerModalViewed({ courseSlug, location: 'single_trailer_modal' })
  }, [courseSlug])

  return control
}
